/* eslint-disable */
import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A high precision floating point value represented as a string */
  BigFloat: { input: string; output: string; }
  /** An arbitrary size integer represented as a string */
  BigInt: { input: string; output: string; }
  /** An opaque string using for tracking a position in results during pagination */
  Cursor: { input: any; output: any; }
  /** A date without time information */
  Date: { input: string; output: string; }
  /** A date and time */
  Datetime: { input: string; output: string; }
  /** A Javascript Object Notation value serialized as a string */
  JSON: { input: string; output: string; }
  /** Any type not handled by the type system */
  Opaque: { input: any; output: any; }
  /** A time without date information */
  Time: { input: string; output: string; }
  /** A universally unique identifier */
  UUID: { input: string; output: string; }
};

export type ActionHistory = Node & {
  __typename?: 'ActionHistory';
  actionHistoryPrivateDataCollection?: Maybe<ActionHistoryPrivateDataConnection>;
  actionIdx: Scalars['BigInt']['output'];
  createdAt: Scalars['Datetime']['output'];
  details: Scalars['JSON']['output'];
  id: Scalars['UUID']['output'];
  /** Globally Unique Record Identifier */
  nodeId: Scalars['ID']['output'];
  playerId?: Maybe<Scalars['UUID']['output']>;
  table?: Maybe<Table>;
  tableId: Scalars['UUID']['output'];
};


export type ActionHistoryActionHistoryPrivateDataCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<ActionHistoryPrivateDataFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActionHistoryPrivateDataOrderBy>>;
};

export type ActionHistoryConnection = {
  __typename?: 'ActionHistoryConnection';
  edges: Array<ActionHistoryEdge>;
  pageInfo: PageInfo;
};

export type ActionHistoryDeleteResponse = {
  __typename?: 'ActionHistoryDeleteResponse';
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output'];
  /** Array of records impacted by the mutation */
  records: Array<ActionHistory>;
};

export type ActionHistoryEdge = {
  __typename?: 'ActionHistoryEdge';
  cursor: Scalars['String']['output'];
  node: ActionHistory;
};

export type ActionHistoryFilter = {
  actionIdx?: InputMaybe<BigIntFilter>;
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<ActionHistoryFilter>>;
  createdAt?: InputMaybe<DatetimeFilter>;
  id?: InputMaybe<UuidFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<ActionHistoryFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<ActionHistoryFilter>>;
  playerId?: InputMaybe<UuidFilter>;
  tableId?: InputMaybe<UuidFilter>;
};

export type ActionHistoryInsertInput = {
  actionIdx?: InputMaybe<Scalars['BigInt']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  details?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  playerId?: InputMaybe<Scalars['UUID']['input']>;
  tableId?: InputMaybe<Scalars['UUID']['input']>;
};

export type ActionHistoryInsertResponse = {
  __typename?: 'ActionHistoryInsertResponse';
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output'];
  /** Array of records impacted by the mutation */
  records: Array<ActionHistory>;
};

export type ActionHistoryOrderBy = {
  actionIdx?: InputMaybe<OrderByDirection>;
  createdAt?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  playerId?: InputMaybe<OrderByDirection>;
  tableId?: InputMaybe<OrderByDirection>;
};

export type ActionHistoryPrivateData = Node & {
  __typename?: 'ActionHistoryPrivateData';
  actionHistory?: Maybe<ActionHistory>;
  actionHistoryId: Scalars['UUID']['output'];
  createdAt: Scalars['Datetime']['output'];
  id: Scalars['UUID']['output'];
  /** Globally Unique Record Identifier */
  nodeId: Scalars['ID']['output'];
  privateDetails: Scalars['JSON']['output'];
  visibleToPlayers?: Maybe<Array<Maybe<Scalars['UUID']['output']>>>;
};

export type ActionHistoryPrivateDataConnection = {
  __typename?: 'ActionHistoryPrivateDataConnection';
  edges: Array<ActionHistoryPrivateDataEdge>;
  pageInfo: PageInfo;
};

export type ActionHistoryPrivateDataDeleteResponse = {
  __typename?: 'ActionHistoryPrivateDataDeleteResponse';
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output'];
  /** Array of records impacted by the mutation */
  records: Array<ActionHistoryPrivateData>;
};

export type ActionHistoryPrivateDataEdge = {
  __typename?: 'ActionHistoryPrivateDataEdge';
  cursor: Scalars['String']['output'];
  node: ActionHistoryPrivateData;
};

export type ActionHistoryPrivateDataFilter = {
  actionHistoryId?: InputMaybe<UuidFilter>;
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<ActionHistoryPrivateDataFilter>>;
  createdAt?: InputMaybe<DatetimeFilter>;
  id?: InputMaybe<UuidFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<ActionHistoryPrivateDataFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<ActionHistoryPrivateDataFilter>>;
  visibleToPlayers?: InputMaybe<UuidListFilter>;
};

export type ActionHistoryPrivateDataInsertInput = {
  actionHistoryId?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  privateDetails?: InputMaybe<Scalars['JSON']['input']>;
  visibleToPlayers?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};

export type ActionHistoryPrivateDataInsertResponse = {
  __typename?: 'ActionHistoryPrivateDataInsertResponse';
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output'];
  /** Array of records impacted by the mutation */
  records: Array<ActionHistoryPrivateData>;
};

export type ActionHistoryPrivateDataOrderBy = {
  actionHistoryId?: InputMaybe<OrderByDirection>;
  createdAt?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
};

export type ActionHistoryPrivateDataUpdateInput = {
  actionHistoryId?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  privateDetails?: InputMaybe<Scalars['JSON']['input']>;
  visibleToPlayers?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};

export type ActionHistoryPrivateDataUpdateResponse = {
  __typename?: 'ActionHistoryPrivateDataUpdateResponse';
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output'];
  /** Array of records impacted by the mutation */
  records: Array<ActionHistoryPrivateData>;
};

export type ActionHistoryUpdateInput = {
  actionIdx?: InputMaybe<Scalars['BigInt']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  details?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  playerId?: InputMaybe<Scalars['UUID']['input']>;
  tableId?: InputMaybe<Scalars['UUID']['input']>;
};

export type ActionHistoryUpdateResponse = {
  __typename?: 'ActionHistoryUpdateResponse';
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output'];
  /** Array of records impacted by the mutation */
  records: Array<ActionHistory>;
};

export type ActionPrompt = Node & {
  __typename?: 'ActionPrompt';
  id: Scalars['UUID']['output'];
  /** Globally Unique Record Identifier */
  nodeId: Scalars['ID']['output'];
  player?: Maybe<TablePlayer>;
  playerId: Scalars['UUID']['output'];
  promptText: Scalars['String']['output'];
  promptedAt: Scalars['Datetime']['output'];
  table?: Maybe<Table>;
  tableId: Scalars['UUID']['output'];
};

export type ActionPromptConnection = {
  __typename?: 'ActionPromptConnection';
  edges: Array<ActionPromptEdge>;
  pageInfo: PageInfo;
};

export type ActionPromptDeleteResponse = {
  __typename?: 'ActionPromptDeleteResponse';
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output'];
  /** Array of records impacted by the mutation */
  records: Array<ActionPrompt>;
};

export type ActionPromptEdge = {
  __typename?: 'ActionPromptEdge';
  cursor: Scalars['String']['output'];
  node: ActionPrompt;
};

export type ActionPromptFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<ActionPromptFilter>>;
  id?: InputMaybe<UuidFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<ActionPromptFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<ActionPromptFilter>>;
  playerId?: InputMaybe<UuidFilter>;
  promptText?: InputMaybe<StringFilter>;
  promptedAt?: InputMaybe<DatetimeFilter>;
  tableId?: InputMaybe<UuidFilter>;
};

export type ActionPromptInsertInput = {
  id?: InputMaybe<Scalars['UUID']['input']>;
  playerId?: InputMaybe<Scalars['UUID']['input']>;
  promptText?: InputMaybe<Scalars['String']['input']>;
  promptedAt?: InputMaybe<Scalars['Datetime']['input']>;
  tableId?: InputMaybe<Scalars['UUID']['input']>;
};

export type ActionPromptInsertResponse = {
  __typename?: 'ActionPromptInsertResponse';
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output'];
  /** Array of records impacted by the mutation */
  records: Array<ActionPrompt>;
};

export type ActionPromptOrderBy = {
  id?: InputMaybe<OrderByDirection>;
  playerId?: InputMaybe<OrderByDirection>;
  promptText?: InputMaybe<OrderByDirection>;
  promptedAt?: InputMaybe<OrderByDirection>;
  tableId?: InputMaybe<OrderByDirection>;
};

export type ActionPromptUpdateInput = {
  id?: InputMaybe<Scalars['UUID']['input']>;
  playerId?: InputMaybe<Scalars['UUID']['input']>;
  promptText?: InputMaybe<Scalars['String']['input']>;
  promptedAt?: InputMaybe<Scalars['Datetime']['input']>;
  tableId?: InputMaybe<Scalars['UUID']['input']>;
};

export type ActionPromptUpdateResponse = {
  __typename?: 'ActionPromptUpdateResponse';
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output'];
  /** Array of records impacted by the mutation */
  records: Array<ActionPrompt>;
};

/** Boolean expression comparing fields on type "BigFloat" */
export type BigFloatFilter = {
  eq?: InputMaybe<Scalars['BigFloat']['input']>;
  gt?: InputMaybe<Scalars['BigFloat']['input']>;
  gte?: InputMaybe<Scalars['BigFloat']['input']>;
  in?: InputMaybe<Array<Scalars['BigFloat']['input']>>;
  is?: InputMaybe<FilterIs>;
  lt?: InputMaybe<Scalars['BigFloat']['input']>;
  lte?: InputMaybe<Scalars['BigFloat']['input']>;
  neq?: InputMaybe<Scalars['BigFloat']['input']>;
};

/** Boolean expression comparing fields on type "BigFloatList" */
export type BigFloatListFilter = {
  containedBy?: InputMaybe<Array<Scalars['BigFloat']['input']>>;
  contains?: InputMaybe<Array<Scalars['BigFloat']['input']>>;
  eq?: InputMaybe<Array<Scalars['BigFloat']['input']>>;
  is?: InputMaybe<FilterIs>;
  overlaps?: InputMaybe<Array<Scalars['BigFloat']['input']>>;
};

/** Boolean expression comparing fields on type "BigInt" */
export type BigIntFilter = {
  eq?: InputMaybe<Scalars['BigInt']['input']>;
  gt?: InputMaybe<Scalars['BigInt']['input']>;
  gte?: InputMaybe<Scalars['BigInt']['input']>;
  in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  is?: InputMaybe<FilterIs>;
  lt?: InputMaybe<Scalars['BigInt']['input']>;
  lte?: InputMaybe<Scalars['BigInt']['input']>;
  neq?: InputMaybe<Scalars['BigInt']['input']>;
};

/** Boolean expression comparing fields on type "BigIntList" */
export type BigIntListFilter = {
  containedBy?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  contains?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  eq?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  is?: InputMaybe<FilterIs>;
  overlaps?: InputMaybe<Array<Scalars['BigInt']['input']>>;
};

/** Boolean expression comparing fields on type "Boolean" */
export type BooleanFilter = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  is?: InputMaybe<FilterIs>;
};

/** Boolean expression comparing fields on type "BooleanList" */
export type BooleanListFilter = {
  containedBy?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  contains?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  eq?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  is?: InputMaybe<FilterIs>;
  overlaps?: InputMaybe<Array<Scalars['Boolean']['input']>>;
};

/** Boolean expression comparing fields on type "Date" */
export type DateFilter = {
  eq?: InputMaybe<Scalars['Date']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<Scalars['Date']['input']>>;
  is?: InputMaybe<FilterIs>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  neq?: InputMaybe<Scalars['Date']['input']>;
};

/** Boolean expression comparing fields on type "DateList" */
export type DateListFilter = {
  containedBy?: InputMaybe<Array<Scalars['Date']['input']>>;
  contains?: InputMaybe<Array<Scalars['Date']['input']>>;
  eq?: InputMaybe<Array<Scalars['Date']['input']>>;
  is?: InputMaybe<FilterIs>;
  overlaps?: InputMaybe<Array<Scalars['Date']['input']>>;
};

/** Boolean expression comparing fields on type "Datetime" */
export type DatetimeFilter = {
  eq?: InputMaybe<Scalars['Datetime']['input']>;
  gt?: InputMaybe<Scalars['Datetime']['input']>;
  gte?: InputMaybe<Scalars['Datetime']['input']>;
  in?: InputMaybe<Array<Scalars['Datetime']['input']>>;
  is?: InputMaybe<FilterIs>;
  lt?: InputMaybe<Scalars['Datetime']['input']>;
  lte?: InputMaybe<Scalars['Datetime']['input']>;
  neq?: InputMaybe<Scalars['Datetime']['input']>;
};

/** Boolean expression comparing fields on type "DatetimeList" */
export type DatetimeListFilter = {
  containedBy?: InputMaybe<Array<Scalars['Datetime']['input']>>;
  contains?: InputMaybe<Array<Scalars['Datetime']['input']>>;
  eq?: InputMaybe<Array<Scalars['Datetime']['input']>>;
  is?: InputMaybe<FilterIs>;
  overlaps?: InputMaybe<Array<Scalars['Datetime']['input']>>;
};

export enum FilterIs {
  NotNull = 'NOT_NULL',
  Null = 'NULL'
}

/** Boolean expression comparing fields on type "Float" */
export type FloatFilter = {
  eq?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<Scalars['Float']['input']>>;
  is?: InputMaybe<FilterIs>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  neq?: InputMaybe<Scalars['Float']['input']>;
};

/** Boolean expression comparing fields on type "FloatList" */
export type FloatListFilter = {
  containedBy?: InputMaybe<Array<Scalars['Float']['input']>>;
  contains?: InputMaybe<Array<Scalars['Float']['input']>>;
  eq?: InputMaybe<Array<Scalars['Float']['input']>>;
  is?: InputMaybe<FilterIs>;
  overlaps?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export enum GameState {
  Active = 'active',
  Completed = 'completed',
  Setup = 'setup'
}

/** Boolean expression comparing fields on type "GameState" */
export type GameStateFilter = {
  eq?: InputMaybe<GameState>;
  in?: InputMaybe<Array<GameState>>;
  is?: InputMaybe<FilterIs>;
  neq?: InputMaybe<GameState>;
};

export type GameTemplateVersions = Node & {
  __typename?: 'GameTemplateVersions';
  changeDescription?: Maybe<Scalars['String']['output']>;
  content: Scalars['String']['output'];
  createdAt: Scalars['Datetime']['output'];
  id: Scalars['UUID']['output'];
  /** Globally Unique Record Identifier */
  nodeId: Scalars['ID']['output'];
  template?: Maybe<GameTemplates>;
  templateId: Scalars['UUID']['output'];
  version: Scalars['Int']['output'];
};

export type GameTemplateVersionsConnection = {
  __typename?: 'GameTemplateVersionsConnection';
  edges: Array<GameTemplateVersionsEdge>;
  pageInfo: PageInfo;
};

export type GameTemplateVersionsDeleteResponse = {
  __typename?: 'GameTemplateVersionsDeleteResponse';
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output'];
  /** Array of records impacted by the mutation */
  records: Array<GameTemplateVersions>;
};

export type GameTemplateVersionsEdge = {
  __typename?: 'GameTemplateVersionsEdge';
  cursor: Scalars['String']['output'];
  node: GameTemplateVersions;
};

export type GameTemplateVersionsFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<GameTemplateVersionsFilter>>;
  changeDescription?: InputMaybe<StringFilter>;
  content?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DatetimeFilter>;
  id?: InputMaybe<UuidFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<GameTemplateVersionsFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<GameTemplateVersionsFilter>>;
  templateId?: InputMaybe<UuidFilter>;
  version?: InputMaybe<IntFilter>;
};

export type GameTemplateVersionsInsertInput = {
  changeDescription?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  templateId?: InputMaybe<Scalars['UUID']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
};

export type GameTemplateVersionsInsertResponse = {
  __typename?: 'GameTemplateVersionsInsertResponse';
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output'];
  /** Array of records impacted by the mutation */
  records: Array<GameTemplateVersions>;
};

export type GameTemplateVersionsOrderBy = {
  changeDescription?: InputMaybe<OrderByDirection>;
  content?: InputMaybe<OrderByDirection>;
  createdAt?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  templateId?: InputMaybe<OrderByDirection>;
  version?: InputMaybe<OrderByDirection>;
};

export type GameTemplateVersionsUpdateInput = {
  changeDescription?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  templateId?: InputMaybe<Scalars['UUID']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
};

export type GameTemplateVersionsUpdateResponse = {
  __typename?: 'GameTemplateVersionsUpdateResponse';
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output'];
  /** Array of records impacted by the mutation */
  records: Array<GameTemplateVersions>;
};

export type GameTemplates = Node & {
  __typename?: 'GameTemplates';
  author?: Maybe<Profile>;
  authorId: Scalars['UUID']['output'];
  content: Scalars['String']['output'];
  createdAt: Scalars['Datetime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  gameTemplateVersionsCollection?: Maybe<GameTemplateVersionsConnection>;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  /** Globally Unique Record Identifier */
  nodeId: Scalars['ID']['output'];
  updatedAt: Scalars['Datetime']['output'];
  version: Scalars['Int']['output'];
};


export type GameTemplatesGameTemplateVersionsCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<GameTemplateVersionsFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GameTemplateVersionsOrderBy>>;
};

export type GameTemplatesConnection = {
  __typename?: 'GameTemplatesConnection';
  edges: Array<GameTemplatesEdge>;
  pageInfo: PageInfo;
};

export type GameTemplatesDeleteResponse = {
  __typename?: 'GameTemplatesDeleteResponse';
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output'];
  /** Array of records impacted by the mutation */
  records: Array<GameTemplates>;
};

export type GameTemplatesEdge = {
  __typename?: 'GameTemplatesEdge';
  cursor: Scalars['String']['output'];
  node: GameTemplates;
};

export type GameTemplatesFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<GameTemplatesFilter>>;
  authorId?: InputMaybe<UuidFilter>;
  content?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DatetimeFilter>;
  description?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  name?: InputMaybe<StringFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<GameTemplatesFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<GameTemplatesFilter>>;
  updatedAt?: InputMaybe<DatetimeFilter>;
  version?: InputMaybe<IntFilter>;
};

export type GameTemplatesInsertInput = {
  authorId?: InputMaybe<Scalars['UUID']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
};

export type GameTemplatesInsertResponse = {
  __typename?: 'GameTemplatesInsertResponse';
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output'];
  /** Array of records impacted by the mutation */
  records: Array<GameTemplates>;
};

export type GameTemplatesOrderBy = {
  authorId?: InputMaybe<OrderByDirection>;
  content?: InputMaybe<OrderByDirection>;
  createdAt?: InputMaybe<OrderByDirection>;
  description?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  name?: InputMaybe<OrderByDirection>;
  updatedAt?: InputMaybe<OrderByDirection>;
  version?: InputMaybe<OrderByDirection>;
};

export type GameTemplatesUpdateInput = {
  authorId?: InputMaybe<Scalars['UUID']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
};

export type GameTemplatesUpdateResponse = {
  __typename?: 'GameTemplatesUpdateResponse';
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output'];
  /** Array of records impacted by the mutation */
  records: Array<GameTemplates>;
};

/** Boolean expression comparing fields on type "ID" */
export type IdFilter = {
  eq?: InputMaybe<Scalars['ID']['input']>;
};

/** Boolean expression comparing fields on type "Int" */
export type IntFilter = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  is?: InputMaybe<FilterIs>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  neq?: InputMaybe<Scalars['Int']['input']>;
};

/** Boolean expression comparing fields on type "IntList" */
export type IntListFilter = {
  containedBy?: InputMaybe<Array<Scalars['Int']['input']>>;
  contains?: InputMaybe<Array<Scalars['Int']['input']>>;
  eq?: InputMaybe<Array<Scalars['Int']['input']>>;
  is?: InputMaybe<FilterIs>;
  overlaps?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/** The root type for creating and mutating data */
export type Mutation = {
  __typename?: 'Mutation';
  addMultipleCardsAction?: Maybe<Scalars['JSON']['output']>;
  assignPrompts?: Maybe<ActionPromptConnection>;
  buildCollectionsJson?: Maybe<Scalars['JSON']['output']>;
  createCollectionAction?: Maybe<Scalars['JSON']['output']>;
  /** Deletes zero or more records from the `ActionHistory` collection */
  deleteFromActionHistoryCollection: ActionHistoryDeleteResponse;
  /** Deletes zero or more records from the `ActionHistoryPrivateData` collection */
  deleteFromActionHistoryPrivateDataCollection: ActionHistoryPrivateDataDeleteResponse;
  /** Deletes zero or more records from the `ActionPrompt` collection */
  deleteFromActionPromptCollection: ActionPromptDeleteResponse;
  /** Deletes zero or more records from the `GameTemplateVersions` collection */
  deleteFromGameTemplateVersionsCollection: GameTemplateVersionsDeleteResponse;
  /** Deletes zero or more records from the `GameTemplates` collection */
  deleteFromGameTemplatesCollection: GameTemplatesDeleteResponse;
  /** Deletes zero or more records from the `NotificationPreferences` collection */
  deleteFromNotificationPreferencesCollection: NotificationPreferencesDeleteResponse;
  /** Deletes zero or more records from the `PieceImageLibrary` collection */
  deleteFromPieceImageLibraryCollection: PieceImageLibraryDeleteResponse;
  /** Deletes zero or more records from the `Profile` collection */
  deleteFromProfileCollection: ProfileDeleteResponse;
  /** Deletes zero or more records from the `PushSubscriptions` collection */
  deleteFromPushSubscriptionsCollection: PushSubscriptionsDeleteResponse;
  /** Deletes zero or more records from the `Table` collection */
  deleteFromTableCollection: TableDeleteResponse;
  /** Deletes zero or more records from the `TableInvite` collection */
  deleteFromTableInviteCollection: TableInviteDeleteResponse;
  /** Deletes zero or more records from the `TablePlayer` collection */
  deleteFromTablePlayerCollection: TablePlayerDeleteResponse;
  dismissPrompt?: Maybe<Scalars['Opaque']['output']>;
  drawCardAction?: Maybe<Scalars['JSON']['output']>;
  getTableForInvite?: Maybe<Scalars['UUID']['output']>;
  /** Adds one or more `ActionHistory` records to the collection */
  insertIntoActionHistoryCollection?: Maybe<ActionHistoryInsertResponse>;
  /** Adds one or more `ActionHistoryPrivateData` records to the collection */
  insertIntoActionHistoryPrivateDataCollection?: Maybe<ActionHistoryPrivateDataInsertResponse>;
  /** Adds one or more `ActionPrompt` records to the collection */
  insertIntoActionPromptCollection?: Maybe<ActionPromptInsertResponse>;
  /** Adds one or more `GameTemplateVersions` records to the collection */
  insertIntoGameTemplateVersionsCollection?: Maybe<GameTemplateVersionsInsertResponse>;
  /** Adds one or more `GameTemplates` records to the collection */
  insertIntoGameTemplatesCollection?: Maybe<GameTemplatesInsertResponse>;
  /** Adds one or more `NotificationPreferences` records to the collection */
  insertIntoNotificationPreferencesCollection?: Maybe<NotificationPreferencesInsertResponse>;
  /** Adds one or more `PieceImageLibrary` records to the collection */
  insertIntoPieceImageLibraryCollection?: Maybe<PieceImageLibraryInsertResponse>;
  /** Adds one or more `Profile` records to the collection */
  insertIntoProfileCollection?: Maybe<ProfileInsertResponse>;
  /** Adds one or more `PushSubscriptions` records to the collection */
  insertIntoPushSubscriptionsCollection?: Maybe<PushSubscriptionsInsertResponse>;
  /** Adds one or more `Table` records to the collection */
  insertIntoTableCollection?: Maybe<TableInsertResponse>;
  /** Adds one or more `TableInvite` records to the collection */
  insertIntoTableInviteCollection?: Maybe<TableInviteInsertResponse>;
  /** Adds one or more `TablePlayer` records to the collection */
  insertIntoTablePlayerCollection?: Maybe<TablePlayerInsertResponse>;
  moveCardAction?: Maybe<Scalars['JSON']['output']>;
  removeCollectionAction?: Maybe<Scalars['JSON']['output']>;
  rollDice?: Maybe<Scalars['JSON']['output']>;
  sendActionReminder?: Maybe<Scalars['JSON']['output']>;
  shuffleCollectionAction?: Maybe<Scalars['JSON']['output']>;
  undoLastAction?: Maybe<Scalars['Boolean']['output']>;
  /** Updates zero or more records in the `ActionHistory` collection */
  updateActionHistoryCollection: ActionHistoryUpdateResponse;
  /** Updates zero or more records in the `ActionHistoryPrivateData` collection */
  updateActionHistoryPrivateDataCollection: ActionHistoryPrivateDataUpdateResponse;
  /** Updates zero or more records in the `ActionPrompt` collection */
  updateActionPromptCollection: ActionPromptUpdateResponse;
  /** Updates zero or more records in the `GameTemplateVersions` collection */
  updateGameTemplateVersionsCollection: GameTemplateVersionsUpdateResponse;
  /** Updates zero or more records in the `GameTemplates` collection */
  updateGameTemplatesCollection: GameTemplatesUpdateResponse;
  /** Updates zero or more records in the `NotificationPreferences` collection */
  updateNotificationPreferencesCollection: NotificationPreferencesUpdateResponse;
  /** Updates zero or more records in the `PieceImageLibrary` collection */
  updatePieceImageLibraryCollection: PieceImageLibraryUpdateResponse;
  /** Updates zero or more records in the `Profile` collection */
  updateProfileCollection: ProfileUpdateResponse;
  /** Updates zero or more records in the `PushSubscriptions` collection */
  updatePushSubscriptionsCollection: PushSubscriptionsUpdateResponse;
  /** Updates zero or more records in the `Table` collection */
  updateTableCollection: TableUpdateResponse;
  /** Updates zero or more records in the `TableInvite` collection */
  updateTableInviteCollection: TableInviteUpdateResponse;
  /** Updates zero or more records in the `TablePlayer` collection */
  updateTablePlayerCollection: TablePlayerUpdateResponse;
};


/** The root type for creating and mutating data */
export type MutationAddMultipleCardsActionArgs = {
  pCards: Array<InputMaybe<Scalars['JSON']['input']>>;
  pCollectionId: Scalars['UUID']['input'];
  pPosition?: InputMaybe<Scalars['String']['input']>;
  pTableId: Scalars['UUID']['input'];
};


/** The root type for creating and mutating data */
export type MutationAssignPromptsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<ActionPromptFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActionPromptOrderBy>>;
  pPromptText: Scalars['String']['input'];
  pTableId: Scalars['UUID']['input'];
  pTargetPlayerIds: Array<InputMaybe<Scalars['UUID']['input']>>;
};


/** The root type for creating and mutating data */
export type MutationBuildCollectionsJsonArgs = {
  pPlayerId?: InputMaybe<Scalars['UUID']['input']>;
  pTableId: Scalars['UUID']['input'];
};


/** The root type for creating and mutating data */
export type MutationCreateCollectionActionArgs = {
  pCollectionType: Scalars['String']['input'];
  pInitialCards?: InputMaybe<Scalars['JSON']['input']>;
  pName: Scalars['String']['input'];
  pOwnerPlayerId?: InputMaybe<Scalars['UUID']['input']>;
  pPublic?: InputMaybe<Scalars['Boolean']['input']>;
  pTableId: Scalars['UUID']['input'];
  pVisibleToPlayers?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


/** The root type for creating and mutating data */
export type MutationDeleteFromActionHistoryCollectionArgs = {
  atMost?: Scalars['Int']['input'];
  filter?: InputMaybe<ActionHistoryFilter>;
};


/** The root type for creating and mutating data */
export type MutationDeleteFromActionHistoryPrivateDataCollectionArgs = {
  atMost?: Scalars['Int']['input'];
  filter?: InputMaybe<ActionHistoryPrivateDataFilter>;
};


/** The root type for creating and mutating data */
export type MutationDeleteFromActionPromptCollectionArgs = {
  atMost?: Scalars['Int']['input'];
  filter?: InputMaybe<ActionPromptFilter>;
};


/** The root type for creating and mutating data */
export type MutationDeleteFromGameTemplateVersionsCollectionArgs = {
  atMost?: Scalars['Int']['input'];
  filter?: InputMaybe<GameTemplateVersionsFilter>;
};


/** The root type for creating and mutating data */
export type MutationDeleteFromGameTemplatesCollectionArgs = {
  atMost?: Scalars['Int']['input'];
  filter?: InputMaybe<GameTemplatesFilter>;
};


/** The root type for creating and mutating data */
export type MutationDeleteFromNotificationPreferencesCollectionArgs = {
  atMost?: Scalars['Int']['input'];
  filter?: InputMaybe<NotificationPreferencesFilter>;
};


/** The root type for creating and mutating data */
export type MutationDeleteFromPieceImageLibraryCollectionArgs = {
  atMost?: Scalars['Int']['input'];
  filter?: InputMaybe<PieceImageLibraryFilter>;
};


/** The root type for creating and mutating data */
export type MutationDeleteFromProfileCollectionArgs = {
  atMost?: Scalars['Int']['input'];
  filter?: InputMaybe<ProfileFilter>;
};


/** The root type for creating and mutating data */
export type MutationDeleteFromPushSubscriptionsCollectionArgs = {
  atMost?: Scalars['Int']['input'];
  filter?: InputMaybe<PushSubscriptionsFilter>;
};


/** The root type for creating and mutating data */
export type MutationDeleteFromTableCollectionArgs = {
  atMost?: Scalars['Int']['input'];
  filter?: InputMaybe<TableFilter>;
};


/** The root type for creating and mutating data */
export type MutationDeleteFromTableInviteCollectionArgs = {
  atMost?: Scalars['Int']['input'];
  filter?: InputMaybe<TableInviteFilter>;
};


/** The root type for creating and mutating data */
export type MutationDeleteFromTablePlayerCollectionArgs = {
  atMost?: Scalars['Int']['input'];
  filter?: InputMaybe<TablePlayerFilter>;
};


/** The root type for creating and mutating data */
export type MutationDismissPromptArgs = {
  pTableId: Scalars['UUID']['input'];
};


/** The root type for creating and mutating data */
export type MutationDrawCardActionArgs = {
  pCount?: InputMaybe<Scalars['Int']['input']>;
  pDrawFrom?: InputMaybe<Scalars['String']['input']>;
  pFromCollectionId: Scalars['UUID']['input'];
  pTableId: Scalars['UUID']['input'];
  pToCollectionId: Scalars['UUID']['input'];
};


/** The root type for creating and mutating data */
export type MutationGetTableForInviteArgs = {
  tableId: Scalars['UUID']['input'];
};


/** The root type for creating and mutating data */
export type MutationInsertIntoActionHistoryCollectionArgs = {
  objects: Array<ActionHistoryInsertInput>;
};


/** The root type for creating and mutating data */
export type MutationInsertIntoActionHistoryPrivateDataCollectionArgs = {
  objects: Array<ActionHistoryPrivateDataInsertInput>;
};


/** The root type for creating and mutating data */
export type MutationInsertIntoActionPromptCollectionArgs = {
  objects: Array<ActionPromptInsertInput>;
};


/** The root type for creating and mutating data */
export type MutationInsertIntoGameTemplateVersionsCollectionArgs = {
  objects: Array<GameTemplateVersionsInsertInput>;
};


/** The root type for creating and mutating data */
export type MutationInsertIntoGameTemplatesCollectionArgs = {
  objects: Array<GameTemplatesInsertInput>;
};


/** The root type for creating and mutating data */
export type MutationInsertIntoNotificationPreferencesCollectionArgs = {
  objects: Array<NotificationPreferencesInsertInput>;
};


/** The root type for creating and mutating data */
export type MutationInsertIntoPieceImageLibraryCollectionArgs = {
  objects: Array<PieceImageLibraryInsertInput>;
};


/** The root type for creating and mutating data */
export type MutationInsertIntoProfileCollectionArgs = {
  objects: Array<ProfileInsertInput>;
};


/** The root type for creating and mutating data */
export type MutationInsertIntoPushSubscriptionsCollectionArgs = {
  objects: Array<PushSubscriptionsInsertInput>;
};


/** The root type for creating and mutating data */
export type MutationInsertIntoTableCollectionArgs = {
  objects: Array<TableInsertInput>;
};


/** The root type for creating and mutating data */
export type MutationInsertIntoTableInviteCollectionArgs = {
  objects: Array<TableInviteInsertInput>;
};


/** The root type for creating and mutating data */
export type MutationInsertIntoTablePlayerCollectionArgs = {
  objects: Array<TablePlayerInsertInput>;
};


/** The root type for creating and mutating data */
export type MutationMoveCardActionArgs = {
  pCardId: Scalars['String']['input'];
  pFromCollectionId: Scalars['UUID']['input'];
  pTableId: Scalars['UUID']['input'];
  pToCollectionId: Scalars['UUID']['input'];
  pToIndex?: InputMaybe<Scalars['Int']['input']>;
};


/** The root type for creating and mutating data */
export type MutationRemoveCollectionActionArgs = {
  pCollectionId: Scalars['UUID']['input'];
  pTableId: Scalars['UUID']['input'];
};


/** The root type for creating and mutating data */
export type MutationRollDiceArgs = {
  pDiceExpression: Scalars['String']['input'];
  pLabel?: InputMaybe<Scalars['String']['input']>;
  pModifier?: InputMaybe<Scalars['Int']['input']>;
  pNumDice: Scalars['Int']['input'];
  pNumSides: Scalars['Int']['input'];
  pTableId: Scalars['UUID']['input'];
};


/** The root type for creating and mutating data */
export type MutationSendActionReminderArgs = {
  pPromptedPlayerId: Scalars['UUID']['input'];
  pTableId: Scalars['UUID']['input'];
};


/** The root type for creating and mutating data */
export type MutationShuffleCollectionActionArgs = {
  pCollectionId: Scalars['UUID']['input'];
  pSeed?: InputMaybe<Scalars['Int']['input']>;
  pTableId: Scalars['UUID']['input'];
};


/** The root type for creating and mutating data */
export type MutationUndoLastActionArgs = {
  pActionIdx: Scalars['BigInt']['input'];
  pNewState: Scalars['JSON']['input'];
  pTableId: Scalars['UUID']['input'];
};


/** The root type for creating and mutating data */
export type MutationUpdateActionHistoryCollectionArgs = {
  atMost?: Scalars['Int']['input'];
  filter?: InputMaybe<ActionHistoryFilter>;
  set: ActionHistoryUpdateInput;
};


/** The root type for creating and mutating data */
export type MutationUpdateActionHistoryPrivateDataCollectionArgs = {
  atMost?: Scalars['Int']['input'];
  filter?: InputMaybe<ActionHistoryPrivateDataFilter>;
  set: ActionHistoryPrivateDataUpdateInput;
};


/** The root type for creating and mutating data */
export type MutationUpdateActionPromptCollectionArgs = {
  atMost?: Scalars['Int']['input'];
  filter?: InputMaybe<ActionPromptFilter>;
  set: ActionPromptUpdateInput;
};


/** The root type for creating and mutating data */
export type MutationUpdateGameTemplateVersionsCollectionArgs = {
  atMost?: Scalars['Int']['input'];
  filter?: InputMaybe<GameTemplateVersionsFilter>;
  set: GameTemplateVersionsUpdateInput;
};


/** The root type for creating and mutating data */
export type MutationUpdateGameTemplatesCollectionArgs = {
  atMost?: Scalars['Int']['input'];
  filter?: InputMaybe<GameTemplatesFilter>;
  set: GameTemplatesUpdateInput;
};


/** The root type for creating and mutating data */
export type MutationUpdateNotificationPreferencesCollectionArgs = {
  atMost?: Scalars['Int']['input'];
  filter?: InputMaybe<NotificationPreferencesFilter>;
  set: NotificationPreferencesUpdateInput;
};


/** The root type for creating and mutating data */
export type MutationUpdatePieceImageLibraryCollectionArgs = {
  atMost?: Scalars['Int']['input'];
  filter?: InputMaybe<PieceImageLibraryFilter>;
  set: PieceImageLibraryUpdateInput;
};


/** The root type for creating and mutating data */
export type MutationUpdateProfileCollectionArgs = {
  atMost?: Scalars['Int']['input'];
  filter?: InputMaybe<ProfileFilter>;
  set: ProfileUpdateInput;
};


/** The root type for creating and mutating data */
export type MutationUpdatePushSubscriptionsCollectionArgs = {
  atMost?: Scalars['Int']['input'];
  filter?: InputMaybe<PushSubscriptionsFilter>;
  set: PushSubscriptionsUpdateInput;
};


/** The root type for creating and mutating data */
export type MutationUpdateTableCollectionArgs = {
  atMost?: Scalars['Int']['input'];
  filter?: InputMaybe<TableFilter>;
  set: TableUpdateInput;
};


/** The root type for creating and mutating data */
export type MutationUpdateTableInviteCollectionArgs = {
  atMost?: Scalars['Int']['input'];
  filter?: InputMaybe<TableInviteFilter>;
  set: TableInviteUpdateInput;
};


/** The root type for creating and mutating data */
export type MutationUpdateTablePlayerCollectionArgs = {
  atMost?: Scalars['Int']['input'];
  filter?: InputMaybe<TablePlayerFilter>;
  set: TablePlayerUpdateInput;
};

export type Node = {
  /** Retrieves a record by `ID` */
  nodeId: Scalars['ID']['output'];
};

export type NotificationPreferences = Node & {
  __typename?: 'NotificationPreferences';
  browserEnabled: Scalars['Boolean']['output'];
  emailEnabled: Scalars['Boolean']['output'];
  minReminderIntervalSeconds: Scalars['Int']['output'];
  /** Globally Unique Record Identifier */
  nodeId: Scalars['ID']['output'];
  player?: Maybe<Profile>;
  playerId: Scalars['UUID']['output'];
  webPushEnabled: Scalars['Boolean']['output'];
};

export type NotificationPreferencesConnection = {
  __typename?: 'NotificationPreferencesConnection';
  edges: Array<NotificationPreferencesEdge>;
  pageInfo: PageInfo;
};

export type NotificationPreferencesDeleteResponse = {
  __typename?: 'NotificationPreferencesDeleteResponse';
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output'];
  /** Array of records impacted by the mutation */
  records: Array<NotificationPreferences>;
};

export type NotificationPreferencesEdge = {
  __typename?: 'NotificationPreferencesEdge';
  cursor: Scalars['String']['output'];
  node: NotificationPreferences;
};

export type NotificationPreferencesFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<NotificationPreferencesFilter>>;
  browserEnabled?: InputMaybe<BooleanFilter>;
  emailEnabled?: InputMaybe<BooleanFilter>;
  minReminderIntervalSeconds?: InputMaybe<IntFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<NotificationPreferencesFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<NotificationPreferencesFilter>>;
  playerId?: InputMaybe<UuidFilter>;
  webPushEnabled?: InputMaybe<BooleanFilter>;
};

export type NotificationPreferencesInsertInput = {
  browserEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  emailEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  minReminderIntervalSeconds?: InputMaybe<Scalars['Int']['input']>;
  playerId?: InputMaybe<Scalars['UUID']['input']>;
  webPushEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NotificationPreferencesInsertResponse = {
  __typename?: 'NotificationPreferencesInsertResponse';
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output'];
  /** Array of records impacted by the mutation */
  records: Array<NotificationPreferences>;
};

export type NotificationPreferencesOrderBy = {
  browserEnabled?: InputMaybe<OrderByDirection>;
  emailEnabled?: InputMaybe<OrderByDirection>;
  minReminderIntervalSeconds?: InputMaybe<OrderByDirection>;
  playerId?: InputMaybe<OrderByDirection>;
  webPushEnabled?: InputMaybe<OrderByDirection>;
};

export type NotificationPreferencesUpdateInput = {
  browserEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  emailEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  minReminderIntervalSeconds?: InputMaybe<Scalars['Int']['input']>;
  playerId?: InputMaybe<Scalars['UUID']['input']>;
  webPushEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NotificationPreferencesUpdateResponse = {
  __typename?: 'NotificationPreferencesUpdateResponse';
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output'];
  /** Array of records impacted by the mutation */
  records: Array<NotificationPreferences>;
};

/** Boolean expression comparing fields on type "Opaque" */
export type OpaqueFilter = {
  eq?: InputMaybe<Scalars['Opaque']['input']>;
  is?: InputMaybe<FilterIs>;
};

/** Defines a per-field sorting order */
export enum OrderByDirection {
  /** Ascending order, nulls first */
  AscNullsFirst = 'AscNullsFirst',
  /** Ascending order, nulls last */
  AscNullsLast = 'AscNullsLast',
  /** Descending order, nulls first */
  DescNullsFirst = 'DescNullsFirst',
  /** Descending order, nulls last */
  DescNullsLast = 'DescNullsLast'
}

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type PieceImageLibrary = Node & {
  __typename?: 'PieceImageLibrary';
  createdAt: Scalars['Datetime']['output'];
  filename: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  /** Globally Unique Record Identifier */
  nodeId: Scalars['ID']['output'];
  storagePath: Scalars['String']['output'];
  user?: Maybe<Profile>;
  userId: Scalars['UUID']['output'];
};

export type PieceImageLibraryConnection = {
  __typename?: 'PieceImageLibraryConnection';
  edges: Array<PieceImageLibraryEdge>;
  pageInfo: PageInfo;
};

export type PieceImageLibraryDeleteResponse = {
  __typename?: 'PieceImageLibraryDeleteResponse';
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output'];
  /** Array of records impacted by the mutation */
  records: Array<PieceImageLibrary>;
};

export type PieceImageLibraryEdge = {
  __typename?: 'PieceImageLibraryEdge';
  cursor: Scalars['String']['output'];
  node: PieceImageLibrary;
};

export type PieceImageLibraryFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<PieceImageLibraryFilter>>;
  createdAt?: InputMaybe<DatetimeFilter>;
  filename?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<PieceImageLibraryFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<PieceImageLibraryFilter>>;
  storagePath?: InputMaybe<StringFilter>;
  userId?: InputMaybe<UuidFilter>;
};

export type PieceImageLibraryInsertInput = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  filename?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  storagePath?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

export type PieceImageLibraryInsertResponse = {
  __typename?: 'PieceImageLibraryInsertResponse';
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output'];
  /** Array of records impacted by the mutation */
  records: Array<PieceImageLibrary>;
};

export type PieceImageLibraryOrderBy = {
  createdAt?: InputMaybe<OrderByDirection>;
  filename?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  storagePath?: InputMaybe<OrderByDirection>;
  userId?: InputMaybe<OrderByDirection>;
};

export type PieceImageLibraryUpdateInput = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  filename?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  storagePath?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

export type PieceImageLibraryUpdateResponse = {
  __typename?: 'PieceImageLibraryUpdateResponse';
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output'];
  /** Array of records impacted by the mutation */
  records: Array<PieceImageLibrary>;
};

export type Profile = Node & {
  __typename?: 'Profile';
  createdAt: Scalars['Datetime']['output'];
  gameTemplatesCollection?: Maybe<GameTemplatesConnection>;
  id: Scalars['UUID']['output'];
  /** Globally Unique Record Identifier */
  nodeId: Scalars['ID']['output'];
  notificationPreferences?: Maybe<NotificationPreferences>;
  pieceImageLibraryCollection?: Maybe<PieceImageLibraryConnection>;
  pushSubscriptionsCollection?: Maybe<PushSubscriptionsConnection>;
  tableCollection?: Maybe<TableConnection>;
  tableInviteCollection?: Maybe<TableInviteConnection>;
  tablePlayerCollection?: Maybe<TablePlayerConnection>;
  username: Scalars['String']['output'];
};


export type ProfileGameTemplatesCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<GameTemplatesFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GameTemplatesOrderBy>>;
};


export type ProfilePieceImageLibraryCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<PieceImageLibraryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PieceImageLibraryOrderBy>>;
};


export type ProfilePushSubscriptionsCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<PushSubscriptionsFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PushSubscriptionsOrderBy>>;
};


export type ProfileTableCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<TableFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TableOrderBy>>;
};


export type ProfileTableInviteCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<TableInviteFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TableInviteOrderBy>>;
};


export type ProfileTablePlayerCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<TablePlayerFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TablePlayerOrderBy>>;
};

export type ProfileConnection = {
  __typename?: 'ProfileConnection';
  edges: Array<ProfileEdge>;
  pageInfo: PageInfo;
};

export type ProfileDeleteResponse = {
  __typename?: 'ProfileDeleteResponse';
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output'];
  /** Array of records impacted by the mutation */
  records: Array<Profile>;
};

export type ProfileEdge = {
  __typename?: 'ProfileEdge';
  cursor: Scalars['String']['output'];
  node: Profile;
};

export type ProfileFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<ProfileFilter>>;
  createdAt?: InputMaybe<DatetimeFilter>;
  id?: InputMaybe<UuidFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<ProfileFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<ProfileFilter>>;
  username?: InputMaybe<StringFilter>;
};

export type ProfileInsertInput = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type ProfileInsertResponse = {
  __typename?: 'ProfileInsertResponse';
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output'];
  /** Array of records impacted by the mutation */
  records: Array<Profile>;
};

export type ProfileOrderBy = {
  createdAt?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  username?: InputMaybe<OrderByDirection>;
};

export type ProfileUpdateInput = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type ProfileUpdateResponse = {
  __typename?: 'ProfileUpdateResponse';
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output'];
  /** Array of records impacted by the mutation */
  records: Array<Profile>;
};

export type PushSubscriptions = Node & {
  __typename?: 'PushSubscriptions';
  auth: Scalars['String']['output'];
  createdAt: Scalars['Datetime']['output'];
  endpoint: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  lastUsedAt?: Maybe<Scalars['Datetime']['output']>;
  /** Globally Unique Record Identifier */
  nodeId: Scalars['ID']['output'];
  p256dh: Scalars['String']['output'];
  player?: Maybe<Profile>;
  playerId: Scalars['UUID']['output'];
};

export type PushSubscriptionsConnection = {
  __typename?: 'PushSubscriptionsConnection';
  edges: Array<PushSubscriptionsEdge>;
  pageInfo: PageInfo;
};

export type PushSubscriptionsDeleteResponse = {
  __typename?: 'PushSubscriptionsDeleteResponse';
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output'];
  /** Array of records impacted by the mutation */
  records: Array<PushSubscriptions>;
};

export type PushSubscriptionsEdge = {
  __typename?: 'PushSubscriptionsEdge';
  cursor: Scalars['String']['output'];
  node: PushSubscriptions;
};

export type PushSubscriptionsFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<PushSubscriptionsFilter>>;
  auth?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DatetimeFilter>;
  endpoint?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  label?: InputMaybe<StringFilter>;
  lastUsedAt?: InputMaybe<DatetimeFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<PushSubscriptionsFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<PushSubscriptionsFilter>>;
  p256dh?: InputMaybe<StringFilter>;
  playerId?: InputMaybe<UuidFilter>;
};

export type PushSubscriptionsInsertInput = {
  auth?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  endpoint?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  lastUsedAt?: InputMaybe<Scalars['Datetime']['input']>;
  p256dh?: InputMaybe<Scalars['String']['input']>;
  playerId?: InputMaybe<Scalars['UUID']['input']>;
};

export type PushSubscriptionsInsertResponse = {
  __typename?: 'PushSubscriptionsInsertResponse';
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output'];
  /** Array of records impacted by the mutation */
  records: Array<PushSubscriptions>;
};

export type PushSubscriptionsOrderBy = {
  auth?: InputMaybe<OrderByDirection>;
  createdAt?: InputMaybe<OrderByDirection>;
  endpoint?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  label?: InputMaybe<OrderByDirection>;
  lastUsedAt?: InputMaybe<OrderByDirection>;
  p256dh?: InputMaybe<OrderByDirection>;
  playerId?: InputMaybe<OrderByDirection>;
};

export type PushSubscriptionsUpdateInput = {
  auth?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  endpoint?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  lastUsedAt?: InputMaybe<Scalars['Datetime']['input']>;
  p256dh?: InputMaybe<Scalars['String']['input']>;
  playerId?: InputMaybe<Scalars['UUID']['input']>;
};

export type PushSubscriptionsUpdateResponse = {
  __typename?: 'PushSubscriptionsUpdateResponse';
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output'];
  /** Array of records impacted by the mutation */
  records: Array<PushSubscriptions>;
};

/** The root type for querying data */
export type Query = {
  __typename?: 'Query';
  /** A pagable collection of type `ActionHistory` */
  actionHistoryCollection?: Maybe<ActionHistoryConnection>;
  /** A pagable collection of type `ActionHistoryPrivateData` */
  actionHistoryPrivateDataCollection?: Maybe<ActionHistoryPrivateDataConnection>;
  /** A pagable collection of type `ActionPrompt` */
  actionPromptCollection?: Maybe<ActionPromptConnection>;
  /** A pagable collection of type `GameTemplateVersions` */
  gameTemplateVersionsCollection?: Maybe<GameTemplateVersionsConnection>;
  /** A pagable collection of type `GameTemplates` */
  gameTemplatesCollection?: Maybe<GameTemplatesConnection>;
  /** Retrieve a record by its `ID` */
  node?: Maybe<Node>;
  /** A pagable collection of type `NotificationPreferences` */
  notificationPreferencesCollection?: Maybe<NotificationPreferencesConnection>;
  /** A pagable collection of type `PieceImageLibrary` */
  pieceImageLibraryCollection?: Maybe<PieceImageLibraryConnection>;
  /** A pagable collection of type `Profile` */
  profileCollection?: Maybe<ProfileConnection>;
  /** A pagable collection of type `PushSubscriptions` */
  pushSubscriptionsCollection?: Maybe<PushSubscriptionsConnection>;
  /** A pagable collection of type `StateCollectionData` */
  stateCollectionDataCollection?: Maybe<StateCollectionDataConnection>;
  /** A pagable collection of type `StateCollections` */
  stateCollectionsCollection?: Maybe<StateCollectionsConnection>;
  /** A pagable collection of type `StateCollectionsWithData` */
  stateCollectionsWithDataCollection?: Maybe<StateCollectionsWithDataConnection>;
  /** A pagable collection of type `Table` */
  tableCollection?: Maybe<TableConnection>;
  /** A pagable collection of type `TableInvite` */
  tableInviteCollection?: Maybe<TableInviteConnection>;
  /** A pagable collection of type `TablePlayer` */
  tablePlayerCollection?: Maybe<TablePlayerConnection>;
};


/** The root type for querying data */
export type QueryActionHistoryCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<ActionHistoryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActionHistoryOrderBy>>;
};


/** The root type for querying data */
export type QueryActionHistoryPrivateDataCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<ActionHistoryPrivateDataFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActionHistoryPrivateDataOrderBy>>;
};


/** The root type for querying data */
export type QueryActionPromptCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<ActionPromptFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActionPromptOrderBy>>;
};


/** The root type for querying data */
export type QueryGameTemplateVersionsCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<GameTemplateVersionsFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GameTemplateVersionsOrderBy>>;
};


/** The root type for querying data */
export type QueryGameTemplatesCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<GameTemplatesFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GameTemplatesOrderBy>>;
};


/** The root type for querying data */
export type QueryNodeArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root type for querying data */
export type QueryNotificationPreferencesCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<NotificationPreferencesFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<NotificationPreferencesOrderBy>>;
};


/** The root type for querying data */
export type QueryPieceImageLibraryCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<PieceImageLibraryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PieceImageLibraryOrderBy>>;
};


/** The root type for querying data */
export type QueryProfileCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<ProfileFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProfileOrderBy>>;
};


/** The root type for querying data */
export type QueryPushSubscriptionsCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<PushSubscriptionsFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PushSubscriptionsOrderBy>>;
};


/** The root type for querying data */
export type QueryStateCollectionDataCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<StateCollectionDataFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<StateCollectionDataOrderBy>>;
};


/** The root type for querying data */
export type QueryStateCollectionsCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<StateCollectionsFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<StateCollectionsOrderBy>>;
};


/** The root type for querying data */
export type QueryStateCollectionsWithDataCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<StateCollectionsWithDataFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<StateCollectionsWithDataOrderBy>>;
};


/** The root type for querying data */
export type QueryTableCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<TableFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TableOrderBy>>;
};


/** The root type for querying data */
export type QueryTableInviteCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<TableInviteFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TableInviteOrderBy>>;
};


/** The root type for querying data */
export type QueryTablePlayerCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<TablePlayerFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TablePlayerOrderBy>>;
};

export type StateCollectionData = Node & {
  __typename?: 'StateCollectionData';
  collection?: Maybe<StateCollections>;
  collectionId: Scalars['UUID']['output'];
  /** Globally Unique Record Identifier */
  nodeId: Scalars['ID']['output'];
  stateData: Scalars['JSON']['output'];
};

export type StateCollectionDataConnection = {
  __typename?: 'StateCollectionDataConnection';
  edges: Array<StateCollectionDataEdge>;
  pageInfo: PageInfo;
};

export type StateCollectionDataEdge = {
  __typename?: 'StateCollectionDataEdge';
  cursor: Scalars['String']['output'];
  node: StateCollectionData;
};

export type StateCollectionDataFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<StateCollectionDataFilter>>;
  collectionId?: InputMaybe<UuidFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<StateCollectionDataFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<StateCollectionDataFilter>>;
};

export type StateCollectionDataOrderBy = {
  collectionId?: InputMaybe<OrderByDirection>;
};

export type StateCollections = Node & {
  __typename?: 'StateCollections';
  collectionType: Scalars['String']['output'];
  createdAt: Scalars['Datetime']['output'];
  id: Scalars['UUID']['output'];
  knownSize: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  /** Globally Unique Record Identifier */
  nodeId: Scalars['ID']['output'];
  ownerPlayerId?: Maybe<Scalars['UUID']['output']>;
  stateCollectionData?: Maybe<StateCollectionData>;
  table?: Maybe<Table>;
  tableId: Scalars['UUID']['output'];
  visibleToPlayers?: Maybe<Array<Maybe<Scalars['UUID']['output']>>>;
};

export type StateCollectionsConnection = {
  __typename?: 'StateCollectionsConnection';
  edges: Array<StateCollectionsEdge>;
  pageInfo: PageInfo;
};

export type StateCollectionsEdge = {
  __typename?: 'StateCollectionsEdge';
  cursor: Scalars['String']['output'];
  node: StateCollections;
};

export type StateCollectionsFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<StateCollectionsFilter>>;
  collectionType?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DatetimeFilter>;
  id?: InputMaybe<UuidFilter>;
  knownSize?: InputMaybe<IntFilter>;
  name?: InputMaybe<StringFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<StateCollectionsFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<StateCollectionsFilter>>;
  ownerPlayerId?: InputMaybe<UuidFilter>;
  tableId?: InputMaybe<UuidFilter>;
  visibleToPlayers?: InputMaybe<UuidListFilter>;
};

export type StateCollectionsOrderBy = {
  collectionType?: InputMaybe<OrderByDirection>;
  createdAt?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  knownSize?: InputMaybe<OrderByDirection>;
  name?: InputMaybe<OrderByDirection>;
  ownerPlayerId?: InputMaybe<OrderByDirection>;
  tableId?: InputMaybe<OrderByDirection>;
};

export type StateCollectionsWithData = Node & {
  __typename?: 'StateCollectionsWithData';
  collectionType?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Datetime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  knownSize?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** Globally Unique Record Identifier */
  nodeId: Scalars['ID']['output'];
  ownerPlayerId?: Maybe<Scalars['UUID']['output']>;
  stateData?: Maybe<Scalars['JSON']['output']>;
  tableId?: Maybe<Scalars['UUID']['output']>;
  visibleToPlayers?: Maybe<Array<Maybe<Scalars['UUID']['output']>>>;
};

export type StateCollectionsWithDataConnection = {
  __typename?: 'StateCollectionsWithDataConnection';
  edges: Array<StateCollectionsWithDataEdge>;
  pageInfo: PageInfo;
};

export type StateCollectionsWithDataEdge = {
  __typename?: 'StateCollectionsWithDataEdge';
  cursor: Scalars['String']['output'];
  node: StateCollectionsWithData;
};

export type StateCollectionsWithDataFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<StateCollectionsWithDataFilter>>;
  collectionType?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DatetimeFilter>;
  id?: InputMaybe<UuidFilter>;
  knownSize?: InputMaybe<IntFilter>;
  name?: InputMaybe<StringFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<StateCollectionsWithDataFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<StateCollectionsWithDataFilter>>;
  ownerPlayerId?: InputMaybe<UuidFilter>;
  tableId?: InputMaybe<UuidFilter>;
  visibleToPlayers?: InputMaybe<UuidListFilter>;
};

export type StateCollectionsWithDataOrderBy = {
  collectionType?: InputMaybe<OrderByDirection>;
  createdAt?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  knownSize?: InputMaybe<OrderByDirection>;
  name?: InputMaybe<OrderByDirection>;
  ownerPlayerId?: InputMaybe<OrderByDirection>;
  tableId?: InputMaybe<OrderByDirection>;
};

/** Boolean expression comparing fields on type "String" */
export type StringFilter = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  iregex?: InputMaybe<Scalars['String']['input']>;
  is?: InputMaybe<FilterIs>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  neq?: InputMaybe<Scalars['String']['input']>;
  regex?: InputMaybe<Scalars['String']['input']>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression comparing fields on type "StringList" */
export type StringListFilter = {
  containedBy?: InputMaybe<Array<Scalars['String']['input']>>;
  contains?: InputMaybe<Array<Scalars['String']['input']>>;
  eq?: InputMaybe<Array<Scalars['String']['input']>>;
  is?: InputMaybe<FilterIs>;
  overlaps?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type Table = Node & {
  __typename?: 'Table';
  actionHistoryCollection?: Maybe<ActionHistoryConnection>;
  actionPromptCollection?: Maybe<ActionPromptConnection>;
  createdAt: Scalars['Datetime']['output'];
  definition: Scalars['JSON']['output'];
  gameState: GameState;
  id: Scalars['UUID']['output'];
  isOpen: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  /** Globally Unique Record Identifier */
  nodeId: Scalars['ID']['output'];
  owner: Scalars['UUID']['output'];
  profile?: Maybe<Profile>;
  state: Scalars['JSON']['output'];
  stateCollectionsCollection?: Maybe<StateCollectionsConnection>;
  tableInviteCollection?: Maybe<TableInviteConnection>;
  tablePlayerCollection?: Maybe<TablePlayerConnection>;
  templateName?: Maybe<Scalars['String']['output']>;
  templateVersion?: Maybe<Scalars['Int']['output']>;
};


export type TableActionHistoryCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<ActionHistoryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActionHistoryOrderBy>>;
};


export type TableActionPromptCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<ActionPromptFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActionPromptOrderBy>>;
};


export type TableStateCollectionsCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<StateCollectionsFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<StateCollectionsOrderBy>>;
};


export type TableTableInviteCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<TableInviteFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TableInviteOrderBy>>;
};


export type TableTablePlayerCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<TablePlayerFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TablePlayerOrderBy>>;
};

export type TableConnection = {
  __typename?: 'TableConnection';
  edges: Array<TableEdge>;
  pageInfo: PageInfo;
};

export type TableDeleteResponse = {
  __typename?: 'TableDeleteResponse';
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output'];
  /** Array of records impacted by the mutation */
  records: Array<Table>;
};

export type TableEdge = {
  __typename?: 'TableEdge';
  cursor: Scalars['String']['output'];
  node: Table;
};

export type TableFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<TableFilter>>;
  createdAt?: InputMaybe<DatetimeFilter>;
  gameState?: InputMaybe<GameStateFilter>;
  id?: InputMaybe<UuidFilter>;
  isOpen?: InputMaybe<BooleanFilter>;
  name?: InputMaybe<StringFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<TableFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<TableFilter>>;
  owner?: InputMaybe<UuidFilter>;
  templateName?: InputMaybe<StringFilter>;
  templateVersion?: InputMaybe<IntFilter>;
};

export type TableInsertInput = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  definition?: InputMaybe<Scalars['JSON']['input']>;
  gameState?: InputMaybe<GameState>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isOpen?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['UUID']['input']>;
  state?: InputMaybe<Scalars['JSON']['input']>;
  templateName?: InputMaybe<Scalars['String']['input']>;
  templateVersion?: InputMaybe<Scalars['Int']['input']>;
};

export type TableInsertResponse = {
  __typename?: 'TableInsertResponse';
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output'];
  /** Array of records impacted by the mutation */
  records: Array<Table>;
};

export type TableInvite = Node & {
  __typename?: 'TableInvite';
  id: Scalars['UUID']['output'];
  invitedAt: Scalars['Datetime']['output'];
  /** Globally Unique Record Identifier */
  nodeId: Scalars['ID']['output'];
  table?: Maybe<Table>;
  tableId: Scalars['UUID']['output'];
  user?: Maybe<Profile>;
  userId: Scalars['UUID']['output'];
};

export type TableInviteConnection = {
  __typename?: 'TableInviteConnection';
  edges: Array<TableInviteEdge>;
  pageInfo: PageInfo;
};

export type TableInviteDeleteResponse = {
  __typename?: 'TableInviteDeleteResponse';
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output'];
  /** Array of records impacted by the mutation */
  records: Array<TableInvite>;
};

export type TableInviteEdge = {
  __typename?: 'TableInviteEdge';
  cursor: Scalars['String']['output'];
  node: TableInvite;
};

export type TableInviteFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<TableInviteFilter>>;
  id?: InputMaybe<UuidFilter>;
  invitedAt?: InputMaybe<DatetimeFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<TableInviteFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<TableInviteFilter>>;
  tableId?: InputMaybe<UuidFilter>;
  userId?: InputMaybe<UuidFilter>;
};

export type TableInviteInsertInput = {
  id?: InputMaybe<Scalars['UUID']['input']>;
  invitedAt?: InputMaybe<Scalars['Datetime']['input']>;
  tableId?: InputMaybe<Scalars['UUID']['input']>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

export type TableInviteInsertResponse = {
  __typename?: 'TableInviteInsertResponse';
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output'];
  /** Array of records impacted by the mutation */
  records: Array<TableInvite>;
};

export type TableInviteOrderBy = {
  id?: InputMaybe<OrderByDirection>;
  invitedAt?: InputMaybe<OrderByDirection>;
  tableId?: InputMaybe<OrderByDirection>;
  userId?: InputMaybe<OrderByDirection>;
};

export type TableInviteUpdateInput = {
  id?: InputMaybe<Scalars['UUID']['input']>;
  invitedAt?: InputMaybe<Scalars['Datetime']['input']>;
  tableId?: InputMaybe<Scalars['UUID']['input']>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

export type TableInviteUpdateResponse = {
  __typename?: 'TableInviteUpdateResponse';
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output'];
  /** Array of records impacted by the mutation */
  records: Array<TableInvite>;
};

export type TableOrderBy = {
  createdAt?: InputMaybe<OrderByDirection>;
  gameState?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  isOpen?: InputMaybe<OrderByDirection>;
  name?: InputMaybe<OrderByDirection>;
  owner?: InputMaybe<OrderByDirection>;
  templateName?: InputMaybe<OrderByDirection>;
  templateVersion?: InputMaybe<OrderByDirection>;
};

export type TablePlayer = Node & {
  __typename?: 'TablePlayer';
  actionPromptCollection?: Maybe<ActionPromptConnection>;
  createdAt: Scalars['Datetime']['output'];
  id: Scalars['UUID']['output'];
  /** Globally Unique Record Identifier */
  nodeId: Scalars['ID']['output'];
  player?: Maybe<Profile>;
  playerId: Scalars['UUID']['output'];
  role: Scalars['String']['output'];
  table?: Maybe<Table>;
  tableId: Scalars['UUID']['output'];
  teamColor: Scalars['String']['output'];
};


export type TablePlayerActionPromptCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<ActionPromptFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActionPromptOrderBy>>;
};

export type TablePlayerConnection = {
  __typename?: 'TablePlayerConnection';
  edges: Array<TablePlayerEdge>;
  pageInfo: PageInfo;
};

export type TablePlayerDeleteResponse = {
  __typename?: 'TablePlayerDeleteResponse';
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output'];
  /** Array of records impacted by the mutation */
  records: Array<TablePlayer>;
};

export type TablePlayerEdge = {
  __typename?: 'TablePlayerEdge';
  cursor: Scalars['String']['output'];
  node: TablePlayer;
};

export type TablePlayerFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<TablePlayerFilter>>;
  createdAt?: InputMaybe<DatetimeFilter>;
  id?: InputMaybe<UuidFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<TablePlayerFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<TablePlayerFilter>>;
  playerId?: InputMaybe<UuidFilter>;
  role?: InputMaybe<StringFilter>;
  tableId?: InputMaybe<UuidFilter>;
  teamColor?: InputMaybe<StringFilter>;
};

export type TablePlayerInsertInput = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  playerId?: InputMaybe<Scalars['UUID']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  tableId?: InputMaybe<Scalars['UUID']['input']>;
  teamColor?: InputMaybe<Scalars['String']['input']>;
};

export type TablePlayerInsertResponse = {
  __typename?: 'TablePlayerInsertResponse';
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output'];
  /** Array of records impacted by the mutation */
  records: Array<TablePlayer>;
};

export type TablePlayerOrderBy = {
  createdAt?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  playerId?: InputMaybe<OrderByDirection>;
  role?: InputMaybe<OrderByDirection>;
  tableId?: InputMaybe<OrderByDirection>;
  teamColor?: InputMaybe<OrderByDirection>;
};

export type TablePlayerUpdateInput = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  playerId?: InputMaybe<Scalars['UUID']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  tableId?: InputMaybe<Scalars['UUID']['input']>;
  teamColor?: InputMaybe<Scalars['String']['input']>;
};

export type TablePlayerUpdateResponse = {
  __typename?: 'TablePlayerUpdateResponse';
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output'];
  /** Array of records impacted by the mutation */
  records: Array<TablePlayer>;
};

export type TableUpdateInput = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  definition?: InputMaybe<Scalars['JSON']['input']>;
  gameState?: InputMaybe<GameState>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isOpen?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['UUID']['input']>;
  state?: InputMaybe<Scalars['JSON']['input']>;
  templateName?: InputMaybe<Scalars['String']['input']>;
  templateVersion?: InputMaybe<Scalars['Int']['input']>;
};

export type TableUpdateResponse = {
  __typename?: 'TableUpdateResponse';
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output'];
  /** Array of records impacted by the mutation */
  records: Array<Table>;
};

/** Boolean expression comparing fields on type "Time" */
export type TimeFilter = {
  eq?: InputMaybe<Scalars['Time']['input']>;
  gt?: InputMaybe<Scalars['Time']['input']>;
  gte?: InputMaybe<Scalars['Time']['input']>;
  in?: InputMaybe<Array<Scalars['Time']['input']>>;
  is?: InputMaybe<FilterIs>;
  lt?: InputMaybe<Scalars['Time']['input']>;
  lte?: InputMaybe<Scalars['Time']['input']>;
  neq?: InputMaybe<Scalars['Time']['input']>;
};

/** Boolean expression comparing fields on type "TimeList" */
export type TimeListFilter = {
  containedBy?: InputMaybe<Array<Scalars['Time']['input']>>;
  contains?: InputMaybe<Array<Scalars['Time']['input']>>;
  eq?: InputMaybe<Array<Scalars['Time']['input']>>;
  is?: InputMaybe<FilterIs>;
  overlaps?: InputMaybe<Array<Scalars['Time']['input']>>;
};

/** Boolean expression comparing fields on type "UUID" */
export type UuidFilter = {
  eq?: InputMaybe<Scalars['UUID']['input']>;
  in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  is?: InputMaybe<FilterIs>;
  neq?: InputMaybe<Scalars['UUID']['input']>;
};

/** Boolean expression comparing fields on type "UUIDList" */
export type UuidListFilter = {
  containedBy?: InputMaybe<Array<Scalars['UUID']['input']>>;
  contains?: InputMaybe<Array<Scalars['UUID']['input']>>;
  eq?: InputMaybe<Array<Scalars['UUID']['input']>>;
  is?: InputMaybe<FilterIs>;
  overlaps?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

export type CreateProfileMutationVariables = Exact<{
  username: Scalars['String']['input'];
  userId: Scalars['UUID']['input'];
}>;


export type CreateProfileMutation = { __typename: 'Mutation', insertIntoProfileCollection?: { __typename: 'ProfileInsertResponse', records: Array<{ __typename: 'Profile', id: string, username: string, createdAt: string }> } | null };

export type GetProfileQueryVariables = Exact<{
  userId: Scalars['UUID']['input'];
}>;


export type GetProfileQuery = { __typename: 'Query', profileCollection?: { __typename: 'ProfileConnection', edges: Array<{ __typename: 'ProfileEdge', node: { __typename: 'Profile', id: string, username: string } }> } | null };

export type GetTableCollectionsWithDataQueryVariables = Exact<{
  tableId: Scalars['UUID']['input'];
}>;


export type GetTableCollectionsWithDataQuery = { __typename: 'Query', stateCollectionsWithDataCollection?: { __typename: 'StateCollectionsWithDataConnection', edges: Array<{ __typename: 'StateCollectionsWithDataEdge', node: { __typename: 'StateCollectionsWithData', id?: string | null, tableId?: string | null, collectionType?: string | null, name?: string | null, stateData?: string | null, visibleToPlayers?: Array<string | null> | null, knownSize?: number | null, createdAt?: string | null, ownerPlayerId?: string | null } }> } | null };

export type CreateCollectionActionMutationVariables = Exact<{
  pTableId: Scalars['UUID']['input'];
  pCollectionType: Scalars['String']['input'];
  pName: Scalars['String']['input'];
  pInitialCards: Scalars['JSON']['input'];
  pVisibleToPlayers: Array<InputMaybe<Scalars['UUID']['input']>> | InputMaybe<Scalars['UUID']['input']>;
  pPublic: Scalars['Boolean']['input'];
  pOwnerPlayerId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type CreateCollectionActionMutation = { __typename: 'Mutation', createCollectionAction?: string | null };

export type RemoveCollectionActionMutationVariables = Exact<{
  pTableId: Scalars['UUID']['input'];
  pCollectionId: Scalars['UUID']['input'];
}>;


export type RemoveCollectionActionMutation = { __typename: 'Mutation', removeCollectionAction?: string | null };

export type MoveCardActionMutationVariables = Exact<{
  pTableId: Scalars['UUID']['input'];
  pCardId: Scalars['String']['input'];
  pFromCollectionId: Scalars['UUID']['input'];
  pToCollectionId: Scalars['UUID']['input'];
  pToIndex?: InputMaybe<Scalars['Int']['input']>;
}>;


export type MoveCardActionMutation = { __typename: 'Mutation', moveCardAction?: string | null };

export type DrawCardActionMutationVariables = Exact<{
  pTableId: Scalars['UUID']['input'];
  pFromCollectionId: Scalars['UUID']['input'];
  pToCollectionId: Scalars['UUID']['input'];
  pCount: Scalars['Int']['input'];
  pDrawFrom: Scalars['String']['input'];
}>;


export type DrawCardActionMutation = { __typename: 'Mutation', drawCardAction?: string | null };

export type ShuffleCollectionActionMutationVariables = Exact<{
  pTableId: Scalars['UUID']['input'];
  pCollectionId: Scalars['UUID']['input'];
  pSeed?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ShuffleCollectionActionMutation = { __typename: 'Mutation', shuffleCollectionAction?: string | null };

export type AddMultipleCardsActionMutationVariables = Exact<{
  pTableId: Scalars['UUID']['input'];
  pCollectionId: Scalars['UUID']['input'];
  pCards: Array<Scalars['JSON']['input']> | Scalars['JSON']['input'];
  pPosition: Scalars['String']['input'];
}>;


export type AddMultipleCardsActionMutation = { __typename: 'Mutation', addMultipleCardsAction?: string | null };

export type CreateTableMutationVariables = Exact<{
  name: Scalars['String']['input'];
  definition: Scalars['JSON']['input'];
  isOpen: Scalars['Boolean']['input'];
  templateName?: InputMaybe<Scalars['String']['input']>;
  templateVersion?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CreateTableMutation = { __typename: 'Mutation', insertIntoTableCollection?: { __typename: 'TableInsertResponse', records: Array<{ __typename: 'Table', id: string, name: string, owner: string, createdAt: string, definition: string }> } | null };

export type JoinTableMutationVariables = Exact<{
  tableId: Scalars['UUID']['input'];
  playerId: Scalars['UUID']['input'];
  teamColor: Scalars['String']['input'];
}>;


export type JoinTableMutation = { __typename: 'Mutation', insertIntoTablePlayerCollection?: { __typename: 'TablePlayerInsertResponse', records: Array<{ __typename: 'TablePlayer', id: string, tableId: string, playerId: string, teamColor: string }> } | null };

export type GetTableDefinitionQueryVariables = Exact<{
  tableId: Scalars['UUID']['input'];
}>;


export type GetTableDefinitionQuery = { __typename: 'Query', tableCollection?: { __typename: 'TableConnection', edges: Array<{ __typename: 'TableEdge', node: { __typename: 'Table', id: string, definition: string } }> } | null };

export type GetTablePlayersCountQueryVariables = Exact<{
  tableId: Scalars['UUID']['input'];
}>;


export type GetTablePlayersCountQuery = { __typename: 'Query', tablePlayerCollection?: { __typename: 'TablePlayerConnection', edges: Array<{ __typename: 'TablePlayerEdge', node: { __typename: 'TablePlayer', id: string } }> } | null };

export type GetUserTemplatesQueryVariables = Exact<{
  userId: Scalars['UUID']['input'];
}>;


export type GetUserTemplatesQuery = { __typename: 'Query', gameTemplatesCollection?: { __typename: 'GameTemplatesConnection', edges: Array<{ __typename: 'GameTemplatesEdge', node: { __typename: 'GameTemplates', id: string, name: string, description?: string | null, content: string, version: number, updatedAt: string } }> } | null };

export type GetTemplateQueryVariables = Exact<{
  templateId: Scalars['UUID']['input'];
}>;


export type GetTemplateQuery = { __typename: 'Query', gameTemplatesCollection?: { __typename: 'GameTemplatesConnection', edges: Array<{ __typename: 'GameTemplatesEdge', node: { __typename: 'GameTemplates', id: string, name: string, description?: string | null, content: string, version: number, authorId: string, createdAt: string, updatedAt: string } }> } | null };

export type CreateTemplateMutationVariables = Exact<{
  name: Scalars['String']['input'];
  content: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateTemplateMutation = { __typename: 'Mutation', insertIntoGameTemplatesCollection?: { __typename: 'GameTemplatesInsertResponse', records: Array<{ __typename: 'GameTemplates', id: string, name: string, content: string, version: number }> } | null };

export type GetTemplateVersionsQueryVariables = Exact<{
  templateId: Scalars['UUID']['input'];
}>;


export type GetTemplateVersionsQuery = { __typename: 'Query', gameTemplateVersionsCollection?: { __typename: 'GameTemplateVersionsConnection', edges: Array<{ __typename: 'GameTemplateVersionsEdge', node: { __typename: 'GameTemplateVersions', id: string, version: number, content: string, changeDescription?: string | null, createdAt: string } }> } | null };

export type SaveTemplateVersionMutationVariables = Exact<{
  templateId: Scalars['UUID']['input'];
  currentVersion: Scalars['Int']['input'];
  nextVersion: Scalars['Int']['input'];
  currentContent: Scalars['String']['input'];
  newContent: Scalars['String']['input'];
}>;


export type SaveTemplateVersionMutation = { __typename: 'Mutation', insertIntoGameTemplateVersionsCollection?: { __typename: 'GameTemplateVersionsInsertResponse', records: Array<{ __typename: 'GameTemplateVersions', id: string }> } | null, updateGameTemplatesCollection: { __typename: 'GameTemplatesUpdateResponse', records: Array<{ __typename: 'GameTemplates', id: string, version: number }> } };

export type GetTableQueryVariables = Exact<{
  tableId: Scalars['UUID']['input'];
}>;


export type GetTableQuery = { __typename: 'Query', tableCollection?: { __typename: 'TableConnection', edges: Array<{ __typename: 'TableEdge', node: { __typename: 'Table', id: string, name: string, owner: string, state: string, definition: string, gameState: GameState, createdAt: string, actionPrompts?: { __typename: 'ActionPromptConnection', edges: Array<{ __typename: 'ActionPromptEdge', node: { __typename: 'ActionPrompt', id: string, playerId: string, promptText: string, promptedAt: string } }> } | null, history?: { __typename: 'ActionHistoryConnection', edges: Array<{ __typename: 'ActionHistoryEdge', node: { __typename: 'ActionHistory', id: string, actionIdx: string, details: string, playerId?: string | null, takenAt: string, privateData?: { __typename: 'ActionHistoryPrivateDataConnection', edges: Array<{ __typename: 'ActionHistoryPrivateDataEdge', node: { __typename: 'ActionHistoryPrivateData', visibleToPlayers?: Array<string | null> | null, privateDetails: string } }> } | null } }> } | null, players?: { __typename: 'TablePlayerConnection', edges: Array<{ __typename: 'TablePlayerEdge', node: { __typename: 'TablePlayer', id: string, teamColor: string, role: string, createdAt: string, player?: { __typename: 'Profile', id: string, username: string } | null } }> } | null } }> } | null, stateCollectionsWithDataCollection?: { __typename: 'StateCollectionsWithDataConnection', edges: Array<{ __typename: 'StateCollectionsWithDataEdge', node: { __typename: 'StateCollectionsWithData', id?: string | null, tableId?: string | null, collectionType?: string | null, name?: string | null, stateData?: string | null, visibleToPlayers?: Array<string | null> | null, knownSize?: number | null, createdAt?: string | null } }> } | null };

export type GetTableSinceQueryVariables = Exact<{
  tableId: Scalars['UUID']['input'];
  sinceActionIdx: Scalars['BigInt']['input'];
}>;


export type GetTableSinceQuery = { __typename: 'Query', tableCollection?: { __typename: 'TableConnection', edges: Array<{ __typename: 'TableEdge', node: { __typename: 'Table', id: string, name: string, owner: string, state: string, definition: string, gameState: GameState, createdAt: string, actionPrompts?: { __typename: 'ActionPromptConnection', edges: Array<{ __typename: 'ActionPromptEdge', node: { __typename: 'ActionPrompt', id: string, playerId: string, promptText: string, promptedAt: string } }> } | null, history?: { __typename: 'ActionHistoryConnection', edges: Array<{ __typename: 'ActionHistoryEdge', node: { __typename: 'ActionHistory', id: string, actionIdx: string, details: string, playerId?: string | null, takenAt: string, privateData?: { __typename: 'ActionHistoryPrivateDataConnection', edges: Array<{ __typename: 'ActionHistoryPrivateDataEdge', node: { __typename: 'ActionHistoryPrivateData', visibleToPlayers?: Array<string | null> | null, privateDetails: string } }> } | null } }> } | null, players?: { __typename: 'TablePlayerConnection', edges: Array<{ __typename: 'TablePlayerEdge', node: { __typename: 'TablePlayer', id: string, teamColor: string, role: string, createdAt: string, player?: { __typename: 'Profile', id: string, username: string } | null } }> } | null } }> } | null, stateCollectionsWithDataCollection?: { __typename: 'StateCollectionsWithDataConnection', edges: Array<{ __typename: 'StateCollectionsWithDataEdge', node: { __typename: 'StateCollectionsWithData', id?: string | null, tableId?: string | null, collectionType?: string | null, name?: string | null, stateData?: string | null, visibleToPlayers?: Array<string | null> | null, knownSize?: number | null, createdAt?: string | null } }> } | null };

export type GetAllTablesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllTablesQuery = { __typename: 'Query', tableCollection?: { __typename: 'TableConnection', edges: Array<{ __typename: 'TableEdge', node: { __typename: 'Table', id: string, name: string, gameState: GameState, isOpen: boolean, owner: string, templateName?: string | null, templateVersion?: number | null, players?: { __typename: 'TablePlayerConnection', edges: Array<{ __typename: 'TablePlayerEdge', node: { __typename: 'TablePlayer', role: string, player?: { __typename: 'Profile', id: string, username: string } | null } }> } | null } }> } | null };

export type JoinTableWithRoleMutationVariables = Exact<{
  tableId: Scalars['UUID']['input'];
  playerId: Scalars['UUID']['input'];
  teamColor: Scalars['String']['input'];
  role: Scalars['String']['input'];
}>;


export type JoinTableWithRoleMutation = { __typename: 'Mutation', insertIntoTablePlayerCollection?: { __typename: 'TablePlayerInsertResponse', records: Array<{ __typename: 'TablePlayer', id: string, tableId: string, playerId: string, teamColor: string, role: string }> } | null };

export type GetTablePlayersCountForJoinQueryVariables = Exact<{
  tableId: Scalars['UUID']['input'];
}>;


export type GetTablePlayersCountForJoinQuery = { __typename: 'Query', tablePlayerCollection?: { __typename: 'TablePlayerConnection', edges: Array<{ __typename: 'TablePlayerEdge', node: { __typename: 'TablePlayer', id: string } }> } | null };

export type CheckTableExistsQueryVariables = Exact<{
  tableId: Scalars['UUID']['input'];
}>;


export type CheckTableExistsQuery = { __typename: 'Query', tableCollection?: { __typename: 'TableConnection', edges: Array<{ __typename: 'TableEdge', node: { __typename: 'Table', id: string } }> } | null };

export type LeaveTableMutationVariables = Exact<{
  tableId: Scalars['UUID']['input'];
}>;


export type LeaveTableMutation = { __typename: 'Mutation', deleteFromTablePlayerCollection: { __typename: 'TablePlayerDeleteResponse', records: Array<{ __typename: 'TablePlayer', id: string }> } };

export type GetUserPieceImagesQueryVariables = Exact<{
  userId: Scalars['UUID']['input'];
}>;


export type GetUserPieceImagesQuery = { __typename: 'Query', pieceImageLibraryCollection?: { __typename: 'PieceImageLibraryConnection', edges: Array<{ __typename: 'PieceImageLibraryEdge', node: { __typename: 'PieceImageLibrary', id: string, storagePath: string, filename: string, createdAt: string } }> } | null };

export type InsertPieceImageMutationVariables = Exact<{
  storagePath: Scalars['String']['input'];
  filename: Scalars['String']['input'];
}>;


export type InsertPieceImageMutation = { __typename: 'Mutation', insertIntoPieceImageLibraryCollection?: { __typename: 'PieceImageLibraryInsertResponse', records: Array<{ __typename: 'PieceImageLibrary', id: string, storagePath: string, filename: string, createdAt: string }> } | null };

export type DeletePieceImageMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DeletePieceImageMutation = { __typename: 'Mutation', deleteFromPieceImageLibraryCollection: { __typename: 'PieceImageLibraryDeleteResponse', records: Array<{ __typename: 'PieceImageLibrary', id: string }> } };

export type ResyncTableStateMutationVariables = Exact<{
  tableId: Scalars['UUID']['input'];
  newState: Scalars['JSON']['input'];
}>;


export type ResyncTableStateMutation = { __typename: 'Mutation', updateTableCollection: { __typename: 'TableUpdateResponse', records: Array<{ __typename: 'Table', id: string }> } };

export type SaveGameMutationVariables = Exact<{
  newActions: Array<ActionHistoryInsertInput> | ActionHistoryInsertInput;
  newState: Scalars['JSON']['input'];
  newDefinition: Scalars['JSON']['input'];
  tableId: Scalars['UUID']['input'];
}>;


export type SaveGameMutation = { __typename: 'Mutation', insertIntoActionHistoryCollection?: { __typename: 'ActionHistoryInsertResponse', records: Array<{ __typename: 'ActionHistory', id: string, actionIdx: string }> } | null, updateTableCollection: { __typename: 'TableUpdateResponse', records: Array<{ __typename: 'Table', id: string }> } };

export type UndoLastActionMutationVariables = Exact<{
  pTableId: Scalars['UUID']['input'];
  pActionIdx: Scalars['BigInt']['input'];
  pNewState: Scalars['JSON']['input'];
}>;


export type UndoLastActionMutation = { __typename: 'Mutation', undoLastAction?: boolean | null };

export type EndGameMutationVariables = Exact<{
  tableId: Scalars['UUID']['input'];
}>;


export type EndGameMutation = { __typename: 'Mutation', updateTableCollection: { __typename: 'TableUpdateResponse', records: Array<{ __typename: 'Table', id: string, gameState: GameState }> } };

export type DeleteTableMutationVariables = Exact<{
  tableId: Scalars['UUID']['input'];
}>;


export type DeleteTableMutation = { __typename: 'Mutation', deleteFromTableCollection: { __typename: 'TableDeleteResponse', records: Array<{ __typename: 'Table', id: string }> } };

export type RollDiceCommandMutationVariables = Exact<{
  pTableId: Scalars['UUID']['input'];
  pDiceExpression: Scalars['String']['input'];
  pNumDice: Scalars['Int']['input'];
  pNumSides: Scalars['Int']['input'];
  pModifier: Scalars['Int']['input'];
  pLabel?: InputMaybe<Scalars['String']['input']>;
}>;


export type RollDiceCommandMutation = { __typename: 'Mutation', rollDice?: string | null };

export type DismissPromptMutationVariables = Exact<{
  tableId: Scalars['UUID']['input'];
  playerId: Scalars['UUID']['input'];
}>;


export type DismissPromptMutation = { __typename: 'Mutation', deleteFromActionPromptCollection: { __typename: 'ActionPromptDeleteResponse', records: Array<{ __typename: 'ActionPrompt', id: string }> } };


export const CreateProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateProfile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"username"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"insertIntoProfileCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"username"},"value":{"kind":"Variable","name":{"kind":"Name","value":"username"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"records"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}}]} as unknown as DocumentNode<CreateProfileMutation, CreateProfileMutationVariables>;
export const GetProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProfile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"profileCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetProfileQuery, GetProfileQueryVariables>;
export const GetTableCollectionsWithDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTableCollectionsWithData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tableId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"stateCollectionsWithDataCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"tableId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tableId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tableId"}},{"kind":"Field","name":{"kind":"Name","value":"collectionType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"stateData"}},{"kind":"Field","name":{"kind":"Name","value":"visibleToPlayers"}},{"kind":"Field","name":{"kind":"Name","value":"knownSize"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"ownerPlayerId"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetTableCollectionsWithDataQuery, GetTableCollectionsWithDataQueryVariables>;
export const CreateCollectionActionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateCollectionAction"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pTableId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pCollectionType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pInitialCards"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pVisibleToPlayers"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pPublic"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pOwnerPlayerId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"createCollectionAction"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pTableId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pTableId"}}},{"kind":"Argument","name":{"kind":"Name","value":"pCollectionType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pCollectionType"}}},{"kind":"Argument","name":{"kind":"Name","value":"pName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pName"}}},{"kind":"Argument","name":{"kind":"Name","value":"pInitialCards"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pInitialCards"}}},{"kind":"Argument","name":{"kind":"Name","value":"pVisibleToPlayers"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pVisibleToPlayers"}}},{"kind":"Argument","name":{"kind":"Name","value":"pPublic"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pPublic"}}},{"kind":"Argument","name":{"kind":"Name","value":"pOwnerPlayerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pOwnerPlayerId"}}}]}]}}]} as unknown as DocumentNode<CreateCollectionActionMutation, CreateCollectionActionMutationVariables>;
export const RemoveCollectionActionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveCollectionAction"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pTableId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pCollectionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"removeCollectionAction"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pTableId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pTableId"}}},{"kind":"Argument","name":{"kind":"Name","value":"pCollectionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pCollectionId"}}}]}]}}]} as unknown as DocumentNode<RemoveCollectionActionMutation, RemoveCollectionActionMutationVariables>;
export const MoveCardActionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MoveCardAction"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pTableId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pCardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pFromCollectionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pToCollectionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pToIndex"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"moveCardAction"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pTableId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pTableId"}}},{"kind":"Argument","name":{"kind":"Name","value":"pCardId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pCardId"}}},{"kind":"Argument","name":{"kind":"Name","value":"pFromCollectionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pFromCollectionId"}}},{"kind":"Argument","name":{"kind":"Name","value":"pToCollectionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pToCollectionId"}}},{"kind":"Argument","name":{"kind":"Name","value":"pToIndex"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pToIndex"}}}]}]}}]} as unknown as DocumentNode<MoveCardActionMutation, MoveCardActionMutationVariables>;
export const DrawCardActionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DrawCardAction"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pTableId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pFromCollectionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pToCollectionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pCount"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pDrawFrom"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"drawCardAction"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pTableId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pTableId"}}},{"kind":"Argument","name":{"kind":"Name","value":"pFromCollectionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pFromCollectionId"}}},{"kind":"Argument","name":{"kind":"Name","value":"pToCollectionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pToCollectionId"}}},{"kind":"Argument","name":{"kind":"Name","value":"pCount"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pCount"}}},{"kind":"Argument","name":{"kind":"Name","value":"pDrawFrom"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pDrawFrom"}}}]}]}}]} as unknown as DocumentNode<DrawCardActionMutation, DrawCardActionMutationVariables>;
export const ShuffleCollectionActionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ShuffleCollectionAction"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pTableId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pCollectionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pSeed"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"shuffleCollectionAction"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pTableId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pTableId"}}},{"kind":"Argument","name":{"kind":"Name","value":"pCollectionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pCollectionId"}}},{"kind":"Argument","name":{"kind":"Name","value":"pSeed"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pSeed"}}}]}]}}]} as unknown as DocumentNode<ShuffleCollectionActionMutation, ShuffleCollectionActionMutationVariables>;
export const AddMultipleCardsActionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddMultipleCardsAction"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pTableId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pCollectionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pCards"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pPosition"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"addMultipleCardsAction"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pTableId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pTableId"}}},{"kind":"Argument","name":{"kind":"Name","value":"pCollectionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pCollectionId"}}},{"kind":"Argument","name":{"kind":"Name","value":"pCards"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pCards"}}},{"kind":"Argument","name":{"kind":"Name","value":"pPosition"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pPosition"}}}]}]}}]} as unknown as DocumentNode<AddMultipleCardsActionMutation, AddMultipleCardsActionMutationVariables>;
export const CreateTableDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateTable"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"definition"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isOpen"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"templateName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"templateVersion"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"insertIntoTableCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"definition"},"value":{"kind":"Variable","name":{"kind":"Name","value":"definition"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"state"},"value":{"kind":"StringValue","value":"{}","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"isOpen"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isOpen"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"templateName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"templateName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"templateVersion"},"value":{"kind":"Variable","name":{"kind":"Name","value":"templateVersion"}}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"records"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"owner"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"definition"}}]}}]}}]}}]} as unknown as DocumentNode<CreateTableMutation, CreateTableMutationVariables>;
export const JoinTableDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"JoinTable"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tableId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"playerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamColor"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"insertIntoTablePlayerCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"tableId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tableId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"playerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"playerId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"teamColor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamColor"}}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"records"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tableId"}},{"kind":"Field","name":{"kind":"Name","value":"playerId"}},{"kind":"Field","name":{"kind":"Name","value":"teamColor"}}]}}]}}]}}]} as unknown as DocumentNode<JoinTableMutation, JoinTableMutationVariables>;
export const GetTableDefinitionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTableDefinition"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tableId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"tableCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tableId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"definition"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetTableDefinitionQuery, GetTableDefinitionQueryVariables>;
export const GetTablePlayersCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTablePlayersCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tableId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"tablePlayerCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"tableId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tableId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetTablePlayersCountQuery, GetTablePlayersCountQueryVariables>;
export const GetUserTemplatesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserTemplates"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"gameTemplatesCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"authorId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"updatedAt"},"value":{"kind":"EnumValue","value":"DescNullsLast"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetUserTemplatesQuery, GetUserTemplatesQueryVariables>;
export const GetTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"templateId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"gameTemplatesCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"templateId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"authorId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetTemplateQuery, GetTemplateQueryVariables>;
export const CreateTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"content"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"insertIntoGameTemplatesCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"content"},"value":{"kind":"Variable","name":{"kind":"Name","value":"content"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"records"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"version"}}]}}]}}]}}]} as unknown as DocumentNode<CreateTemplateMutation, CreateTemplateMutationVariables>;
export const GetTemplateVersionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTemplateVersions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"templateId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"gameTemplateVersionsCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"templateId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"templateId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"version"},"value":{"kind":"EnumValue","value":"DescNullsLast"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"changeDescription"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetTemplateVersionsQuery, GetTemplateVersionsQueryVariables>;
export const SaveTemplateVersionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SaveTemplateVersion"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"templateId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"currentVersion"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nextVersion"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"currentContent"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newContent"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"insertIntoGameTemplateVersionsCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"templateId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"templateId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"version"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nextVersion"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"content"},"value":{"kind":"Variable","name":{"kind":"Name","value":"currentContent"}}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"records"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"updateGameTemplatesCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"templateId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"content"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newContent"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"version"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nextVersion"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"records"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}}]}}]}}]}}]} as unknown as DocumentNode<SaveTemplateVersionMutation, SaveTemplateVersionMutationVariables>;
export const GetTableDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTable"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tableId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"tableCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tableId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"owner"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"definition"}},{"kind":"Field","name":{"kind":"Name","value":"gameState"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","alias":{"kind":"Name","value":"actionPrompts"},"name":{"kind":"Name","value":"actionPromptCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"playerId"}},{"kind":"Field","name":{"kind":"Name","value":"promptText"}},{"kind":"Field","name":{"kind":"Name","value":"promptedAt"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"history"},"name":{"kind":"Name","value":"actionHistoryCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"actionIdx"},"value":{"kind":"EnumValue","value":"DescNullsLast"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"10000"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"actionIdx"}},{"kind":"Field","name":{"kind":"Name","value":"details"}},{"kind":"Field","name":{"kind":"Name","value":"playerId"}},{"kind":"Field","alias":{"kind":"Name","value":"takenAt"},"name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","alias":{"kind":"Name","value":"privateData"},"name":{"kind":"Name","value":"actionHistoryPrivateDataCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"visibleToPlayers"}},{"kind":"Field","name":{"kind":"Name","value":"privateDetails"}}]}}]}}]}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"players"},"name":{"kind":"Name","value":"tablePlayerCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"player"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}}]}},{"kind":"Field","name":{"kind":"Name","value":"teamColor"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"stateCollectionsWithDataCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"tableId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tableId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tableId"}},{"kind":"Field","name":{"kind":"Name","value":"collectionType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"stateData"}},{"kind":"Field","name":{"kind":"Name","value":"visibleToPlayers"}},{"kind":"Field","name":{"kind":"Name","value":"knownSize"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetTableQuery, GetTableQueryVariables>;
export const GetTableSinceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTableSince"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tableId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sinceActionIdx"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BigInt"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"tableCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tableId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"owner"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"definition"}},{"kind":"Field","name":{"kind":"Name","value":"gameState"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","alias":{"kind":"Name","value":"actionPrompts"},"name":{"kind":"Name","value":"actionPromptCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"playerId"}},{"kind":"Field","name":{"kind":"Name","value":"promptText"}},{"kind":"Field","name":{"kind":"Name","value":"promptedAt"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"history"},"name":{"kind":"Name","value":"actionHistoryCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"actionIdx"},"value":{"kind":"EnumValue","value":"DescNullsLast"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"10000"}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"actionIdx"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"gt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sinceActionIdx"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"actionIdx"}},{"kind":"Field","name":{"kind":"Name","value":"details"}},{"kind":"Field","name":{"kind":"Name","value":"playerId"}},{"kind":"Field","alias":{"kind":"Name","value":"takenAt"},"name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","alias":{"kind":"Name","value":"privateData"},"name":{"kind":"Name","value":"actionHistoryPrivateDataCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"visibleToPlayers"}},{"kind":"Field","name":{"kind":"Name","value":"privateDetails"}}]}}]}}]}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"players"},"name":{"kind":"Name","value":"tablePlayerCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"player"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}}]}},{"kind":"Field","name":{"kind":"Name","value":"teamColor"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"stateCollectionsWithDataCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"tableId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tableId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tableId"}},{"kind":"Field","name":{"kind":"Name","value":"collectionType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"stateData"}},{"kind":"Field","name":{"kind":"Name","value":"visibleToPlayers"}},{"kind":"Field","name":{"kind":"Name","value":"knownSize"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetTableSinceQuery, GetTableSinceQueryVariables>;
export const GetAllTablesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAllTables"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"tableCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"gameState"}},{"kind":"Field","name":{"kind":"Name","value":"isOpen"}},{"kind":"Field","name":{"kind":"Name","value":"owner"}},{"kind":"Field","name":{"kind":"Name","value":"templateName"}},{"kind":"Field","name":{"kind":"Name","value":"templateVersion"}},{"kind":"Field","alias":{"kind":"Name","value":"players"},"name":{"kind":"Name","value":"tablePlayerCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"player"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}}]}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetAllTablesQuery, GetAllTablesQueryVariables>;
export const JoinTableWithRoleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"JoinTableWithRole"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tableId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"playerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamColor"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"role"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"insertIntoTablePlayerCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"tableId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tableId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"playerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"playerId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"teamColor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamColor"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"role"},"value":{"kind":"Variable","name":{"kind":"Name","value":"role"}}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"records"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tableId"}},{"kind":"Field","name":{"kind":"Name","value":"playerId"}},{"kind":"Field","name":{"kind":"Name","value":"teamColor"}},{"kind":"Field","name":{"kind":"Name","value":"role"}}]}}]}}]}}]} as unknown as DocumentNode<JoinTableWithRoleMutation, JoinTableWithRoleMutationVariables>;
export const GetTablePlayersCountForJoinDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTablePlayersCountForJoin"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tableId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"tablePlayerCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"tableId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tableId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetTablePlayersCountForJoinQuery, GetTablePlayersCountForJoinQueryVariables>;
export const CheckTableExistsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CheckTableExists"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tableId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"tableCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tableId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CheckTableExistsQuery, CheckTableExistsQueryVariables>;
export const LeaveTableDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"LeaveTable"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tableId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"deleteFromTablePlayerCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"tableId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tableId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"atMost"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"records"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<LeaveTableMutation, LeaveTableMutationVariables>;
export const GetUserPieceImagesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserPieceImages"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"pieceImageLibraryCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"EnumValue","value":"DescNullsLast"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"storagePath"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetUserPieceImagesQuery, GetUserPieceImagesQueryVariables>;
export const InsertPieceImageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertPieceImage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"storagePath"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filename"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"insertIntoPieceImageLibraryCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"storagePath"},"value":{"kind":"Variable","name":{"kind":"Name","value":"storagePath"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"filename"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filename"}}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"records"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"storagePath"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}}]} as unknown as DocumentNode<InsertPieceImageMutation, InsertPieceImageMutationVariables>;
export const DeletePieceImageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeletePieceImage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"deleteFromPieceImageLibraryCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"records"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<DeletePieceImageMutation, DeletePieceImageMutationVariables>;
export const ResyncTableStateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ResyncTableState"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tableId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newState"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"updateTableCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"state"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newState"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tableId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"records"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<ResyncTableStateMutation, ResyncTableStateMutationVariables>;
export const SaveGameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"saveGame"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newActions"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ActionHistoryInsertInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newState"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newDefinition"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tableId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"insertIntoActionHistoryCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newActions"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"records"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"actionIdx"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"updateTableCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"state"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newState"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"definition"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newDefinition"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tableId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"records"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<SaveGameMutation, SaveGameMutationVariables>;
export const UndoLastActionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"undoLastAction"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pTableId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pActionIdx"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BigInt"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pNewState"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"undoLastAction"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pTableId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pTableId"}}},{"kind":"Argument","name":{"kind":"Name","value":"pActionIdx"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pActionIdx"}}},{"kind":"Argument","name":{"kind":"Name","value":"pNewState"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pNewState"}}}]}]}}]} as unknown as DocumentNode<UndoLastActionMutation, UndoLastActionMutationVariables>;
export const EndGameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"EndGame"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tableId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"updateTableCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tableId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"gameState"},"value":{"kind":"EnumValue","value":"completed"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"records"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"gameState"}}]}}]}}]}}]} as unknown as DocumentNode<EndGameMutation, EndGameMutationVariables>;
export const DeleteTableDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteTable"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tableId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"deleteFromTableCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tableId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"records"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteTableMutation, DeleteTableMutationVariables>;
export const RollDiceCommandDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"rollDiceCommand"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pTableId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pDiceExpression"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pNumDice"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pNumSides"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pModifier"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pLabel"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"rollDice"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pTableId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pTableId"}}},{"kind":"Argument","name":{"kind":"Name","value":"pDiceExpression"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pDiceExpression"}}},{"kind":"Argument","name":{"kind":"Name","value":"pNumDice"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pNumDice"}}},{"kind":"Argument","name":{"kind":"Name","value":"pNumSides"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pNumSides"}}},{"kind":"Argument","name":{"kind":"Name","value":"pModifier"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pModifier"}}},{"kind":"Argument","name":{"kind":"Name","value":"pLabel"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pLabel"}}}]}]}}]} as unknown as DocumentNode<RollDiceCommandMutation, RollDiceCommandMutationVariables>;
export const DismissPromptDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DismissPrompt"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tableId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"playerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"deleteFromActionPromptCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"tableId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tableId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"playerId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"playerId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"atMost"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"records"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<DismissPromptMutation, DismissPromptMutationVariables>;